import React, { useState, useRef } from "react";

import FileUpload from "./FileUpload";
import pdf from "../../assets/svg/icons/pdf.svg";

const uploadToStorage = async (storageInstance, files, folder = "") => {
  return await Promise.allSettled(
    files.map((file) => {
      return storageInstance.upload(file, folder);
    })
  );
};

const FileUploadToStorage = (props) => {
  const [uploadInProgress, setUploadInProgress] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(true);

  const currentImage = useRef(null);

  const outputFormat = props.outputFormat || "string";
  const handleFileUploadSuccessFromUser = async (files) => {
    setUploadInProgress(true);
    try {
      const uploads = await uploadToStorage(
        props.storageInstance,
        files,
        props.folder || ""
      );
      const results = uploads.map((elem) => elem.value.url);
      if (outputFormat === "string") {
        if (results.length === 1) {
          props.onChange(results[0]);
        } else {
          props.onChange(JSON.stringify(results, null, 2));
        }
      } else if (outputFormat === "array") {
        props.onChange(results);
      }

      setUploadInProgress(false);
      setUploadSuccess(true);
    } catch (err) {
      setUploadInProgress(false);
      setUploadSuccess(false);
    }
  };
  const handleDeleted = (files) => {
    props.onChange("");
  };

  const handleFailedImage = () => {
    if (currentImage && currentImage.current && props.value) {
      currentImage.current.src = pdf;
    }
  };

  return (
    <div className="form-group">
      <FileUpload
        {...props}
        uploadFailureHandler={() => {}}
        uploadSuccessfulHandler={handleFileUploadSuccessFromUser}
        onFilesDeleted={handleDeleted}
        multiple={props.multiple || false}
        allowedTypes="image/png, image/jpeg, image/jpg, .pdf, .doc, .docx, .HEIC"
        {...{
          uploadInProgress,
          setUploadInProgress,
          uploadSuccess,
          setUploadSuccess,
        }}
      />
      <div className="d-flex align-items-center justify-content-start">
        <img
          ref={currentImage}
          src={props.value}
          height={50}
          width={50}
          onError={handleFailedImage}
          alt={props.value}
        />
      </div>
    </div>
  );
};

export default FileUploadToStorage;
